// extracted by mini-css-extract-plugin
export var chip = "_dj-0";
export var filterDropdown = "_dj-5";
export var filterItem = "_dj-6";
export var icon = "_dj-1";
export var removeButton = "_dj-3";
export var removeIcon = "_dj-4";
export var separator = "_dj-2";